<template>
  <div class="position-pannel">
    <div class="position-pannel__search">
      <b-form-radio
        v-for="item in addressTypeDcits"
        :key="item.value"
        v-model="addressType"
        name="some-radios"
        :value="item.value"
        @change="addressTypeChange"
      >
        {{ item.label }}
      </b-form-radio>
    </div>
    <gtable-crud
      ref="crud"
      :option="option"
      :data="redata"
      :page="page"
      :form.sync="form"
      :loading="loading"
      :before-close="beforeClose"
      :before-open="beforeOpen"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    />
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import addressAPI from '@/api/base/address'
import { BFormRadio } from 'bootstrap-vue'
import projectAPI from '@/api/base/project'

export default {
  components: {
    BFormRadio,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      redata: [],
      form: {
        addressType: 1,
      },
      addressType: 1,
      loading: false,
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      drawerType: '',
      updateAuditData: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    }
  },
  computed: {
    option() {
      const option = {
        search: false,
        drawerAppendToParent: true,
        notHandler: true,
        columns: [
          {
            label: this.i18n('addressName'),
            field: 'addressName',
          },
          {
            label: this.i18n('addressType'),
            field: 'addressType',
            dictField: 'addressTypeName',
            formOption: {
              type: 'radio',
              dictData: this.addressTypeDcits,
            },
          },
          {
            label: this.i18n('project'),
            field: 'projectId',
            hide: true,
            columnHide: true,
            formOption: {
              type: 'select',
              dictCode: 'project',
              hide: this.form.addressType === 2,
            },
          },
          {
            label: this.i18n('position'),
            field: 'position',
            formOption: {
              hide: true,
            },
          },
          {
            label: this.i18n('lat'),
            field: 'addressLat',
            hide: true,
            columnHide: true,
          },
          {
            label: this.i18n('lng'),
            field: 'addressLon',
            hide: true,
            columnHide: true,
          },
        ],
      }
      return option
    },
    addressTypeDcits() {
      return [
        {
          label: this.i18n('project'),
          value: 1,
        },
        {
          label: this.i18n('other'),
          value: 2,
        },
      ]
    },
  },
  watch: {
    'form.projectId': {
      handler(e, old) {
        if (e && (old || this.drawerType === 'add')) {
          this.$refs.crud.formLoading = true
          projectAPI.detail({ id: e }).then((res) => {
            this.form.addressLat = res.data.data.lat
            this.form.addressLon = res.data.data.lng
            if (!this.form.addressName) {
              this.form.addressName = res.data.data.projectName
            }
            this.$refs.crud.formLoading = false
          })
        }
      },
    },
  },
  mounted() {
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await addressAPI.getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, { addressType: this.addressType })
      )
      const { data } = res.data
      this.page.total = data.total
      const result = []
      data.records.forEach((item) => {
        const param = item
        param.addressTypeName = this.addressTypeDcits.find(
          (o) => o.value === item.addressType
        ).label
        param.position = `Lat: ${item.addressLat}, Lng: ${item.addressLon}`
        result.push(param)
      })
      this.redata = result
      this.loading = false
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.attendanceSchemePosition.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      if (params.addressType === 2) {
        delete params.projectId
      }
      addressAPI
        .add(params)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.$emit('refresh')
          await this.onLoad(this.page)
          done()
        })
        .catch((err) => {
          done()
        })
    },
    handleUpdate(done, row = {}) {
      const params = row
      if (params.addressType === 2) {
        delete params.projectId
      }
      delete params.updateUser
      delete params.createDept
      delete params.createUser
      delete params.status
      addressAPI
        .edit(params)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.$emit('refresh')
          await this.onLoad(this.page)
          done()
        })
        .catch((err) => {
          done()
        })
    },
    handleRowDel(row, done) {
      addressAPI
        .remove(row.id)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.$emit('refresh')
          await this.onLoad(this.page)
        })
        .catch((err) => {
          done()
        })
    },
    async refreshChange() {
      await this.onLoad(this.page)
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    addressTypeChange(e) {
      this.form.addressType = e
      this.onLoad(this.page)
    },
    beforeClose(done) {
      this.form = {
        addressType: 1,
      }
      done()
    },
    beforeOpen(done, type) {
      this.drawerType = type
      done()
    },
  },
}
</script>
<style lang="scss">
.position-pannel {
  height: 100%;
  overflow: auto;
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    &-sm {
      width: 200px;
    }
  }
  &__search {
    position: absolute;
    display: flex;
    left: 2.9rem;
    top: 50px;
    z-index: 1000;
    & > div {
      margin-right: 20px;
    }
  }
}
</style>
